import { Container, Reveal } from '@/components/common'
import heroBg from '@/assets/images/IBON-World-Launch-14.jpeg'

export const AboutHero = () => {
  return (
    <section className="relative isolate overflow-hidden bg-ibon-dark">
      <div
        className="absolute inset-0 -z-20 bg-cover bg-center"
        style={{ backgroundImage: `url(${heroBg})` }}
        aria-hidden
      />
      <div className="absolute inset-0 -z-10 bg-ibon-dark/85" />
      <div className="absolute inset-0 -z-10 bg-linear-to-b from-ibon-dark/60 via-transparent to-ibon-dark" />

      <Container className="py-28 lg:py-40">
        <Reveal variant="up" delay={100}>
          <h1 className="mt-8 max-w-5xl text-4xl font-bold leading-[1.03] tracking-[-0.02em] text-white sm:text-5xl lg:text-7xl">
            A visionary organisation{' '}
            <span className="text-white/40">shaping the next generation.</span>
          </h1>
        </Reveal>

        <Reveal variant="up" delay={220}>
          <p className="mt-9 max-w-3xl text-lg leading-relaxed text-white/75">
            IBON World is a visionary non-governmental organisation transforming the future of{' '}
            <span className="font-semibold text-white">
              entrepreneurship, education, and cultural exchange
            </span>{' '}
            across Africa and the Caribbean. At the heart of our work is the BEC Framework:
            Business, Education, and Culture, a bold model designed to unlock the potential of young
            people and empower them to lead change in their communities. We are not just building
            programmes; we are building a movement of next-generation leaders, creators, and
            innovators.
          </p>
        </Reveal>
      </Container>
    </section>
  )
}
